<template>
  <p
    :class="{
      'b-paragraph': true,
      'b-paragraph--no-margin': noMargin
    }"
  >
    <slot />
  </p>
</template>

<script>
export default {
  name: "BParagraph",
  props: {
    noMargin: {
      default: false,
      type: Boolean,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.b-paragraph {
  @include font-style(
    (
      xs: p,
      m: p1
    )
  );

  &--no-margin {
    margin: 0;
  }
}
</style>
